import { useEffect, useState, Suspense } from "react";
import "./App.css";
import { Context } from "./context/contextapi";
import { ToastContainer } from "react-toastify";
import { isValuePresent } from "./utils";
import { RoutesArray } from "./Routes";
import { AuthProvider } from "techveda-react-auth";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useUserPermissions } from "./component/Global/useUserPermissions";
import { getPermissionObjects } from "./component/Global/permissions";

function App() {
  const [user, setUser] = useState({});
  const [auth, setAuth] = useState("");
  // eslint-disable-next-line
  const [loggedIn, setLoggedIn] = useState(false);
  const [newuser, setNewuser] = useState(false);

  const userPermissions = useUserPermissions(); // e.g., ["SUB_ADMIN"]
  const { permittedMenu } = getPermissionObjects(userPermissions);
  const menuItems = permittedMenu.map((item) => ({
    key: item.key,
    path: item.path,
    element: item.element,
    name: item.name,
    style: { background: "white", color: "white", marginBottom: "20px" },
    fontSize: "1rem",
  }));

  const menu = localStorage.getItem("issidebar");

  useEffect(() => {
    if (permittedMenu?.length > 0 && menu == true) {
      // Navigate to first allowed path
      window.location.href = menuItems[0].path;
      localStorage.setItem("issidebar", false);
    }
  }, [permittedMenu]);

  const renderRoutes = (routes) => {
    return (
      <>
        {" "}
        {routes.map(({ path, element, children, index }) => (
          <Route
            key={path || "index"}
            path={path}
            index={index}
            element={<>{element}</>}
          >
            {children && renderRoutes(children)}
          </Route>
        ))}
      </>
    );
  };

  return (
    <>
      <ToastContainer />
      <Router>
        <AuthProvider
          storageKey="data"
          enableRouterIntegration={true}
          onLogin={(user) => {
            console.log("User logged in:", user);
          }}
          onLogout={() => {
            console.log("User logged out");
          }}
        >
          <Context.Provider
            value={{
              user,
              setUser,
              auth,
              setAuth,
              isValuePresent,
              setLoggedIn,
              newuser,
              setNewuser,
            }}
          >
            <Suspense fallback={<div>Loading...</div>}>
              <Routes>{renderRoutes(RoutesArray)}</Routes>
            </Suspense>
          </Context.Provider>
        </AuthProvider>
      </Router>
    </>
  );
}

export default App;
